export default __webpack_public_path__ + "static/media/settings.bcd39dea.svg";